import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ListSelectItem from 'components/application/ListSelectItem';

const moreBreakpoint = 3;

export default function ListSelect({
  field,
  items,
  onChange,
  removeErrorStyling,
  selectableItems,
}) {
  const [showMore, setShowMore] = useState(false);

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const addNewItem = ({ value }) => {
    if (value.length > 0) {
      const newItems = [...items];

      newItems.push({ value });
      onChange({ oldItems: items, newItems }, { target: { name: field } });
      removeErrorStyling({ target: { name: field } });
    }
  };

  const filteredSelectableItems = selectableItems.filter(
    (selectableItem) =>
      !items.map((item) => item.value).includes(selectableItem.value),
  );
  const visibleItems =
    filteredSelectableItems.length < moreBreakpoint || showMore ?
      filteredSelectableItems
    : filteredSelectableItems.slice(0, moreBreakpoint);

  return (
    <div className='app-form__select-list'>
      {visibleItems.map((item, index) => (
        <ListSelectItem item={item} key={index} onClick={addNewItem} />
      ))}
      {filteredSelectableItems.length > moreBreakpoint && !showMore && (
        <div className='tw-flex tw-items-center'>
          <button
            className='app-link tw-bg-transparent tw-align-baseline tw-text-blue-500 hover:tw-text-blue-300 active:tw-text-blue-300'
            onClick={() => setShowMore(true)}
          >
            {i18nTShared('showMoreWithCount', {
              count: filteredSelectableItems.length - moreBreakpoint,
            })}
          </button>
        </div>
      )}
    </div>
  );
}

ListSelect.propTypes = {
  field: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  selectableItems: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};
